import React from "react";
import PropTypes from "prop-types";
import { BarcodeScannerDialog } from "@clubInventory/components/dialog";
import { useSkuAddToListContext } from "./SkuAddToListContext";

/**
 * ScannerDialog - 掃描對話框子組件
 */
const ScannerDialog = ({ title = "商品掃描", placeholder = "請掃描或輸入商品SKU", continuousScan = false, ...otherProps }) => {
	const { showScanDialog, handleCloseScanDialog, handleScanSuccess, handleScanError } = useSkuAddToListContext();

	return (
		<BarcodeScannerDialog
			title={title}
			open={showScanDialog}
			onClose={handleCloseScanDialog}
			onScanSuccess={handleScanSuccess}
			onScanError={handleScanError}
			placeholder={placeholder}
			continuousScan={continuousScan}
			{...otherProps}
		/>
	);
};

ScannerDialog.propTypes = {
	title: PropTypes.string,
	placeholder: PropTypes.string,
	continuousScan: PropTypes.bool,
};

ScannerDialog.displayName = "SkuAddToList.ScannerDialog";

export default ScannerDialog;
